import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import { LocalGraphColor } from "../colors";

export default function MultiLineChart() {
  const state = useSelector((store) => store.analyze);
  const {
    multiLineChartDataPrepared,
    selectedScenarioName,
    tableData,
    selectedDataPoints,
    showChart,
  } = state;
  const { periods, seriesData } = multiLineChartDataPrepared;

  // const colorMapping = {
  //   TTM: "#0000FF",
  //   IMS: "#000000",
  //   MDR: "#964B00",
  //   "LE Diagnostics": "green",
  //   "Final Quota": "#FF9800",
  //   "Original Quota": "#F57C00",
  //   Month: "#800080",
  // };

  const colorMapping = {
    "Ex-Factory": "#3366cc",
    "DeliveredQTY": "#ADD8E6",
    "IQVIA - MIDAS": "#000000",
     SIT: "purple",
    "Quota": "#8B8000",
    "Final Quota": "#8B8000",
    "Original Quota": "#F57C00",
    "Initial Quota": "#F57C00",
    "Consensus FC": "#74b72e",
    "SK Wholesalers sales": "#39a78e",
    "Fin.FC-based": "#aaaa11",
    "SC FC-based": "#cc8033",
    "Financial Forecast":"#006400",
    "SC Forecast" :"#FF00FF",
    "AI Forecast":"#EC5066",
    "GERS":"#a0a0a0",
    Month: "#800080",
    "Direct To Pharmacy Sales":"#993366",
    "Ex-Factory + Direct To Pharmacy Sales":"#8E4585",
    "IQVIA - MIDAS + Direct To Pharmacy Sales":"#DF73FF",
  };

  const getMismatchedSourceIDs = (data, colorMapping) => {
    console.log("multiLineChartDataPrepared",multiLineChartDataPrepared);
    return data
      .filter((item) => !colorMapping.hasOwnProperty(item.dataSourceName))
      .filter((item) => {
        return Object.keys(item).some((key) => {
          return !isNaN(item[key]) && parseInt(item[key], 10) > 0;
        });
      })
      .map((item) => item.dataSourceID);
  };

  let selectedData = tableData?.filter((row) =>
    selectedDataPoints?.includes(row.dataSourceID)
  );
  let selectedDataSources = selectedData.map((row) => row.dataSourceName);
  let mismatchedSourceIDs = getMismatchedSourceIDs(tableData, colorMapping);

  // Match the dataSourceIDs with the colors
  const matchedColors = matchColors(mismatchedSourceIDs, LocalGraphColor);

  // const getColorsByIndices = (colors, mismatchedSourceIDs) => mismatchedSourceIDs.map(index => colors[index]);

  // const x = getColorsByIndices(LocalGraphColor, mismatchedSourceIDs);

  // Function to match the dataSourceIDs with the colors array
  function matchColors(dataSourceIDs, colorsArray) {
    const result = {};
    dataSourceIDs.forEach((id, index) => {
      const dataSourceName = tableData.find(
        (item) => item.dataSourceID === id
      ).dataSourceName;
      result[dataSourceName] = colorsArray[id % colorsArray.length];
    });
    return result;
  }

  // Function to get color for series by name or LocalGraphColors
  function getColor(seriesName, index) {
    return colorMapping[seriesName] || matchedColors[seriesName];
  }

  let filteredSeries = seriesData.filter((series) =>
    selectedDataSources.includes(series.name)
  );

  // Apply colors to each series based on the name or fallback
  const updatedSeriesData = filteredSeries.map((series, index) => ({
    ...series,
    color: getColor(series.name, index), // Get color from colorMapping or fallbackColors
  }));

  // Extract the colors from the updated series data
  const seriesColors = updatedSeriesData.map((series) => series.color);

  const series = [...filteredSeries];

  const UpdatedSeries = series.map(item =>({
    ...item,
    data:item.data.map(value =>(value===0?null:value))
  }));

  const options = {
    title: {
      text: `Analyze: ${selectedScenarioName} Data`,
      align: "left",
    },
    tooltip: {
      y: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
    },
    xaxis: {
      categories: [...periods],
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
    },
    stroke: {
      width: 2,
    },
    markers: {
      size: 5,
    },
    colors: seriesColors,
  };

  //  // Update the series data to include the color in the data array
  //  const seriesWithColors = updatedSeriesData.map(series => ({
  // 	name: series.name,
  // 	data: series.data,
  // 	color: series.color, // Include the color in the series data
  //   }));

  return (
    // added class name to get this element.
    <Box className={"multiLineChart"} sx={{display: showChart ? "block" : "none"}}>
      <Chart
        options={options}
        series={series}
        type="line"
        height={"400"}
        width={"95%"}
      />
    </Box>
  );
}
